module.exports = __webpack_public_path__ + "assets/img/2023_2.2def06f8.png";